import SessionQ from '@/queries/SessionQ'
import type { Query } from '@/client/query'

export default function getPositionInSeries(session: Query): number | null {
  const sessionId = session(SessionQ.id) ?? 0

  // We filter for `"series_id" IS NOT NULL` so that index of
  // non-series sessions returns null.
  const orderedSessionIdsInSeries: number[] = session.many`
    FROM ${SessionQ} s2
    WHERE
        s2."series_id" = ${SessionQ.series_id} AND
        s2."series_id" IS NOT NULL AND
        s2.deleted_at IS NULL
    ORDER BY
        s2."start_date" ASC
  `.map(s => s`id`)
  const seriesIndex = orderedSessionIdsInSeries.indexOf(sessionId)

  // Consumer expects this to be 1-indexed.
  return seriesIndex !== -1 ? seriesIndex + 1 : null
}
